export default __webpack_public_path__ + "img/e7fe1b9b9c2a127f329ee9c2e2f5d4f3.svg";